import { render, staticRenderFns } from "./derivativesInfo.vue?vue&type=template&id=561fe353&scoped=true&"
import script from "./derivativesInfo.vue?vue&type=script&lang=js&"
export * from "./derivativesInfo.vue?vue&type=script&lang=js&"
import style0 from "./derivativesInfo.vue?vue&type=style&index=0&id=561fe353&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "561fe353",
  null
  
)

export default component.exports